/* Chrôma Hospitality / Wholesale — shared price-lock state (TEAM ORIGINATOR) */
(function () {
  if (window.__chromaTrade) return;
  window.__chromaTrade = true;
  var html = document.documentElement, KEY = 'chroma-trade-unlocked';
  var posted = /[?&]contact_posted=true/.test(location.search);
  var hash = (location.hash || '').slice(1);
  var open = html.classList.contains('chp-trade-open');
  try { if (localStorage.getItem(KEY) === '1') open = true; } catch (e) {}
  if (posted && hash.indexOf('ChpTradeUnlock') === 0) {
    open = true;
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    document.addEventListener('DOMContentLoaded', function () {
      var t = document.querySelector('[data-ct-pricing]');
      if (t) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 80);
    });
  }
  if (open) html.classList.add('chp-trade-open');

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ct-posted-for]').forEach(function (m) {
      if (posted && hash === m.getAttribute('data-ct-posted-for')) {
        var b = m.parentElement.querySelector('.ct-enq-body'); if (b) b.style.display = 'none';
      } else m.remove();
    });
  });

  function initPricing(scope) {
    scope.querySelectorAll('[data-ct-pricing]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      var tiers = (root.getAttribute('data-tiers') || '20,30,40,50').split(',').map(function (x) { return parseFloat(x) || 0; });
      var cases = 1, box = root.querySelector('.ct-tiers');
      var fmt = function (v) { return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
      if (root.getAttribute('data-mode') === 'table') {
        root.querySelectorAll('[data-pack]').forEach(function (p) {
          var retail = parseFloat(p.getAttribute('data-retail')) || 0;
          var per = parseInt(p.getAttribute('data-per-case'), 10) || 1;
          var body = p.querySelector('[data-rows]'); if (!body) return;
          body.innerHTML = tiers.map(function (pct, i) {
            var n = i + 1, last = i === tiers.length - 1;
            var price = Math.round(retail * (1 - pct / 100) * 100) / 100;
            return '<tr><td>' + n + (last ? '+' : '') + '</td><td>' + (per * n) + (last ? '+' : '') + '</td><td>' + pct + '%</td><td class="ct-cell-price">' + fmt(price) + '</td></tr>';
          }).join('');
        });
        return;
      }
      if (!box) return;
      tiers.forEach(function (pct, i) {
        var n = i + 1, last = i === tiers.length - 1;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ct-tier';
        b.innerHTML = '<b>' + n + (last ? '+' : '') + (n === 1 && !last ? ' case' : ' cases') + '</b><span>' + pct + '% off</span>';
        b.addEventListener('click', function () { cases = n; paint(); });
        box.appendChild(b);
      });
      function paint() {
        [].forEach.call(box.children, function (b, i) { b.setAttribute('aria-pressed', i + 1 === cases ? 'true' : 'false'); });
        var off = (tiers[cases - 1] || 0) / 100, last = cases === tiers.length;
        root.querySelectorAll('[data-pack]').forEach(function (p) {
          var retail = parseFloat(p.getAttribute('data-retail')) || 0;
          var per = parseInt(p.getAttribute('data-per-case'), 10) || 1;
          var price = Math.round(retail * (1 - off) * 100) / 100, sets = per * cases;
          p.querySelector('[data-price]').textContent = fmt(price);
          p.querySelector('[data-sets]').textContent = cases + (last ? '+' : '') + (cases === 1 && !last ? ' case · ' : ' cases · ') + sets + (last ? '+' : '') + ' sets';
          p.querySelector('[data-total]').textContent = (last ? 'From ' : 'Order total ') + fmt(price * sets);
        });
      }
      paint();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPricing(document); });
  else initPricing(document);
  document.addEventListener('shopify:section:load', function (e) { initPricing(e.target); });
})();
